import { render, staticRenderFns } from "./HomePublication.vue?vue&type=template&id=c0c4abb4&"
import script from "./HomePublication.vue?vue&type=script&lang=js&"
export * from "./HomePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports